import { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import ErrorFeedback from 'Components/ErrorFeedback'
import PageContainer from 'Components/PageContainer'
import { Loading, ToastContainer, Tooltip } from 'mailup-web-components'
import Body from './components/Body'
import Footer from './components/Footer'
import Header from './components/Header'
import ModalSharedLists from './components/ModalSharedLists/ModalSharedLists'
import ModalShowHistory from './components/ModalShowHistory/ModalShowHistory'

import { cleanupCallback, initCallback } from './recoil/callbacks/callbacks'
import { pageState } from './recoil/state/page'

const SourceEdit = () => {
  const { idType, idSource } = useParams()
  const { search } = useLocation()
  const { loading, loaded, error, severity, loadingMsg, exportJson } =
    useRecoilValue(pageState)

  const name = new URLSearchParams(search).get('name')
  const url = new URLSearchParams(search).get('url')

  const init = useRecoilCallback(initCallback, [])
  const cleanup = useRecoilCallback(cleanupCallback, [])

  useEffect(() => {
    init({ idSource: +idSource, idType: +idType, name, url })
    return () => cleanup()
  }, [])

  const onReload = async () => {
    await cleanup()
    init({ idSource: +idSource, idType: +idType, name, url })
  }

  return (
    <>
      <ToastContainer />
      <Tooltip />
      <Loading open={loading || exportJson} text={loadingMsg} />
      <ModalShowHistory />
      <ModalSharedLists />
      <Header />
      <PageContainer>
        <ErrorFeedback
          severity={severity}
          error={error}
          onClickReload={onReload}
        />
        {!error && loaded && (
          <>
            <Body />
            <Footer />
          </>
        )}
      </PageContainer>
    </>
  )
}

export default SourceEdit
